<script lang="ts">
  import editorStore from '../editor.store';
  import type {ToolbarAction} from './ToolbarModule';
  export let item: ToolbarAction;
</script>

{#if item}
  <svelte:component this={item.component} {...item.props} />
{/if}
